














import Vue from "vue";
import { Component } from "vue-property-decorator";
import { JinroPlayerDocument, JinroGameDocument } from "@/services/datatypes";
import PlayerNameList from "@/components/shared/PlayerNameList.vue";

@Component({
  components: {
    PlayerNameList,
  },
})
export default class Default extends Vue {
  get survivors(): Array<JinroPlayerDocument> {
    if (!this.$store.state.jinroGame) {
      return [];
    }
    const survivors: Array<JinroPlayerDocument> = this.$store.state.jinroGame
      .survivors;
    return survivors;
  }

  get killedPlayers(): Array<JinroPlayerDocument> {
    if (!this.$store.state.jinroGame) {
      return [];
    }

    const killedPlayers: Array<JinroPlayerDocument> = this.$store.state
      .jinroGame.killedPlayers;
    return killedPlayers;
  }

  get killedPlayersByJinro(): Array<JinroPlayerDocument> {
    if (!this.$store.state.jinroGame) {
      return [];
    }

    const jinroGame = this.$store.state.jinroGame as JinroGameDocument;
    const killedPlayersByJinro = jinroGame.killedPlayersByJinroAttack as Array<
      JinroPlayerDocument
    >;

    return killedPlayersByJinro;
  }
}
